import InputProduct from './../../components/_inputs/InputProduct.vue'
export default (field) => {
  if (field === 'product_id') {
    return InputProduct
  }
}
